import { useEffect } from 'react';

/**
 * Hook to add or remove a class on the body element
 * @param className - The class name to add or remove
 * @param enabled - Whether to add or remove the class
 */
export function useBodyClass(className: string, enabled: boolean) {
  useEffect(() => {
    document.body.classList.toggle(className, enabled);

    return () => {
      document.body.classList.remove(className);
    };
  }, [className, enabled]);
}
